import React from "react";

import { BsArrowRight } from "react-icons/bs";

import "./Products.scss";

const ProductSection = (props) => {
  return (
    <div
      className={`row ${props.imgLeft ? "flex-row-reverse" : null} ${
        props.className
      }`}
    >
      <div
        className={`product-${props?.content} col-12 col-lg-6 pl-12`}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <h1 className="heading-4 mb-3 text-black">{props.title}</h1>
        <p
          style={{
            fontWeight: 500,
            fontSize: "1.125rem",
            marginBottom: "1rem",
          }}
        >
          {props.subtitle}
        </p>
        <div className="text-secondary fs-6 fw-normal">{props.children}</div>

        <a
          className="link-arrow"
          href={props.link}
          target="_blank"
          rel="noreferrer"
          style={{
            fontWeight: 600,
          }}
        >
          Explore now
          <BsArrowRight
            style={{ marginLeft: "0.3125rem" }}
            className="arrow-left"
          />
        </a>
      </div>

      <div className="col-12 col-lg-6 pt-5 pt-lg-0">
        <img
          src={props.img}
          alt={props.title}
          className={`h-100 w-100 ${
            props.imgLeft ? "float-start" : "float-lg-end"
          }`}
        />
      </div>
    </div>
  );
};

const Products = () => {
  return (
    <div className="home-container">
      <div className="products-list-project">
        <ProductSection
          title="Surviv.fun"
          subtitle="Survive and have fun"
          link="https://www.surviv.fun"
          img={require("assets/images/products/surviv.png")}
          className="product-section"
          content="content-left"
          imgLeft
        >
          <p>
            The new 2D survival game inspired by the legendary Surviv.io, played
            by millions worldwide. Surviv.fun is the next evolution, featuring
            better game performance, enhanced in-game assets, and multiple
            exciting game modes.
          </p>
        </ProductSection>

        <ProductSection
          title="Gafi Network"
          subtitle="The network of Game Finance"
          link="https://gafi.network/"
          img={require("assets/images/products/gafi-lg.svg").default}
          className="product-section"
          content="content-right"
        >
          <p>
            The Network of Game Finance, The foundation builds with top-class
            technologies, architecture, and mechanisms for the next wave of
            Blockchain-based Gaming.&nbsp;
            <a
              href="https://gafi.network"
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: "500",
              }}
            >
              Gafi Network
            </a>{" "}
            project supported by{" "}
            <a
              href="https://web3.foundation"
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: "500",
              }}
            >
              Web3.foundation
            </a>
          </p>
        </ProductSection>
      </div>
    </div>
  );
};

export default Products;
